// extracted by mini-css-extract-plugin
module.exports = {"category":"styles_category__2Qn--","contentOffers":"styles_contentOffers__3lt4c"};